import React from "react";
import { StyleSheet, Text, View, CheckBox } from "react-native";
import type { HabitVisibility } from "../types";
export type Props = {
  visibility?: HabitVisibility;
  onChange: (arg0: HabitVisibility) => void;
};
export default function VisibilityOption(props: Props) {
  // for now, the only meaningful states are "public" and "private"
  const enabled = props.visibility === "public";
  return (
    <View style={styles.container}>
      <Text>Public:</Text>
      <CheckBox
        style={styles.checkbox}
        value={enabled}
        onValueChange={(checked) =>
          props.onChange(checked ? "public" : "private")
        }
      />
    </View>
  );
}
const styles = StyleSheet.create({
  checkbox: {
    marginLeft: 5,
    marginRight: 5,
  },
  container: {
    flexDirection: "row",
    marginTop: 8,
    marginBottom: 0,
    marginLeft: 5,
    marginRight: 5,
  },
});
